// PermissaoBase: todas as permissões do Grupo Econômico
// PermissaoInicial: todos os módulos sem permissao, para qdo for adicionar usuário
// ModulosTitle: Títulos dos módulos para impressão na tela
// gruposAcessoTitles: Títulos dos grupos de acesso(permissões) para impressão na tela

const state = {
    clientsList: null,
    grupoEconomico: null,
    grupoEconomicoList: null,
    grupoEconomicoModulos: null,
    gruposAcessoTitles: {
        autorizador: "Autorizador",
        faturamento: "Faturamento",
        portal: "Geral"
    },
    id:{
        dadosdocronograma: null
    },
    modulosTitles: {
        autorizador: "Autorizador",
        faturamento: "Faturamento",
        portal: "Geral"
      },
    operadoras:{},
    permissaoBase: {},
    permissaoBaseCadastro: {},
    permissaoInicial: {},
    parceirosList: [
        {
          "parceiro_id": 167,
          "parceiro_ds": "PARCEIRO 1",
        },
        {
          "parceiro_id": 147,
          "parceiro_ds": "PARCEIRO 2",
        },
        {
          "parceiro_id": 93,
          "parceiro_ds": "PARCEIRO 3",
        },
        {
          "parceiro_id": 4,
          "parceiro_ds": "PARCEIRO 4",
        }
    ]
};
const mutations = {
    saveId: (state, obj) => {
        state.id[obj.pathName] = obj.id
    },
    updateGrupoEconomico: (state, resp) => {
        state.grupoEconomico = resp
    },
    updateGrupoEconomicoList: (state, resp) => {
        state.grupoEconomicoList = resp.dados
        state.clientsList = resp.dados.map(geco => {return {value: geco.grupo_id, label: geco.grupo_ds} })
    },
    updateGrupoEconomicoModulos: (state, resp) => {
        state.grupoEconomicoModulos = resp
    },
    updateModulos: (state, obj) => {
        sessionStorage.setItem('grupoEconomico', obj.grupo_economico)
        state.grupo_economico = obj.grupo_economico
        if(obj.naoParametrizaveis){
            state.permissaoBaseCadastro = {...obj.permissao_base}
            state.permissaoInicial = Object.keys(obj.permissao_base).reduce((acum, mod) => {
                acum[mod] = [] 
                return acum
            }, {})
        } else {
            state.permissaoBase = {...obj.permissao_base}
        }
        state.modulosTitles = obj.modulo
        state.gruposAcessoTitles = obj.grupo_acesso
        
    },
    updateOperadoras:(state, list) => {
        state.operadoras = list? list.reduce((obj, oper) => {
            obj[oper.id] = oper.oper_nome
            return obj
         },{}) : []
    }
};
const actions = {
    async changeGrupoEconomico({state}, grupoEconomico){
        state.grupoEconomico = Number(grupoEconomico)
        await this.dispatch("permissions/getModulos", {grupoEconomico}, {root: true}).then(() => {
            return true
        })
        let filtersToClear = ['identNaOperadoraFilter', 'identPagamentosFilter', 'lotesPendentes', 'pagamentosPublicados', 'pagamentosEmProcessamento', 'recursosGlosaFilter']
        await filtersToClear.forEach(filter =>  this.commit("recebiveis/resetFilter", filter, {root: true}) )
        return true
    },
    async getModulos({commit}, opts){
        let naoParametrizaveis = opts.naoParametrizaveis ? opts.naoParametrizaveis : null
        let obj = {
            query: [{ 
                Modulo: "portal",
                Acao: "getmodulos",
                Payload: {
                    grupo_economico: opts.grupoEconomico,
                    nao_parametrizaveis: naoParametrizaveis
                }
            }]
        }

        const resp = await this.dispatch("request/doRequest", obj);
        resp.grupo_economico = opts.grupoEconomico;
        resp.naoParametrizaveis = naoParametrizaveis;
        commit("updateModulos", resp);

        return true;
    },
    async getGrupoEconomicoById({commit}, grupo_economico){
        let obj = {
            query: [{ 
                Modulo: "portal",
                Acao: "getgrupoeconomico",
                Payload: {
                    grupo_economico: grupo_economico,
                }
            }]
        }
        await this.dispatch("request/doRequest", obj).then(resp => {
            let { grupo_ds, grupo_id, prestador } = resp
            commit("updateGrupoEconomicoList", {dados: [{grupo_ds, grupo_id, prestador}]});
        })
    },
    async getGrupoEconomicoList({commit}){
        let obj = {
            query: [{ 
                Modulo: "portal",
                Acao: "getgruposeconomicos",
                Payload: {}
            }]
        }
        await this.dispatch("request/doRequest", obj).then(resp => {
            commit("updateGrupoEconomicoList", resp);
        })
    },
    async verifyAuth() {
        await this.dispatch("authenticator/loginRequired");
        const userData = await this.getters['userData/getUserData']();

        if(userData.Id != null) {
            return true;
        }

        let grupoEconomico = userData.grupo_economico;

        await this.commit("userData/updateUserData", userData, {root: true})
        await this.commit("permissions/updateGrupoEconomico", Number(grupoEconomico), {root: true})
        await this.dispatch("permissions/getModulos", {grupoEconomico}, {root: true});

        if(userData.UsuarioTradimus){
            await this.dispatch("permissions/getGrupoEconomicoList", grupoEconomico, {root: true})
        } else {
            await this.dispatch("permissions/getGrupoEconomicoById", grupoEconomico, {root: true})
        }

        await this.dispatch("permissions/getModulos", {grupoEconomico, naoParametrizaveis: true}, {root: true})

        return true
    },
    async getOperadoras({commit}, opts){
        let geco = opts.grupoEconomico? opts.grupoEconomico : this.state.permissions.grupoEconomico
        let obj = {
            url: '/api/proxy/postdata', 
            query: [{ 
                Modulo: "Portal",
                Acao: "getoperadoras",
                Payload: {
                    ...opts,
                    grupo_economico: geco,
                }
          }],
          noLoader: true
        }
        let list = await this.dispatch("request/doRequest", obj).then(response => {
            if(opts.modulo_operadora == "faturamento" || opts.modulo_operadora == "recebiveis" ){
                this.state.faturamento.listOperadora = response.dados ? response.dados : []
            } else if(opts.modulo_operadora == "autorizador"){
                this.state.autorizador.listOperadora = response.dados ? response.dados : []
            }
            return response.dados
        });
        commit("updateOperadoras", list)
        return list
    },
}
const getters = {
    getPermissoesModulo: (state) => (module) =>  {
        let list = state.permissaoBase[module].map(el => { return {value: el, label:state.gruposAcessoTitles[el]} })
        return list
      },
    getModulosList: (state) => () =>  {
        return Object.entries(state.modulosTitles).filter(mod => Object.keys(state.permissaoBase).includes(mod[0])).map(mod => {return {value:mod[0], label: mod[1]} })
      },
    getPrestadoresByGeco: (state) => () =>  {
        let prestadoresList = (state.grupoEconomicoList)? state.grupoEconomicoList.find(geco => geco.grupo_id == state.grupoEconomico).prestador : []
        return prestadoresList
    },
    getPrestadoresByUser: (state) => (prestadoresListId) =>  {
    let prestadoresList = state.grupoEconomicoList.find(geco => geco.grupo_id == state.grupoEconomico)
    
    prestadoresList = prestadoresList.prestador.filter(prestador => prestadoresListId.includes(prestador.id))
    return prestadoresList
    },
    getGrupoPrestadoresList: (state) => () =>  {
        if(!state.grupoEconomicoList) return []
        let grupoPrestadoresList = state.grupoEconomicoList.reduce((list,geco)=>{
            let grupo = {
                nome: geco.grupo_ds,
                id: "g_" + geco.grupo_id,
                is_header: true
            };
          list.push({ divider: true });
          list.push(grupo);
          list.push({ divider: true });
          geco.prestador.forEach(function (prestador) {
            let cliente = {
                nome: prestador.prest_nome,
                id: prestador.id,
                grupo_id: "g_" + geco.grupo_id,
                is_header: false
            }
            list.push(cliente);
          })
            return list
        },[])
        
        return grupoPrestadoresList
    },
}

export default {
    namespaced: true,
    root: true,
    actions,
    mutations,
    state,
    getters
};